/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForGcpOrganization extends models.ServiceAccountNativeDetailsBaseForGcp {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForGcpOrganization");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForGcpOrganization.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForGcpOrganization>): ServiceAccountNativeDetailsForGcpOrganization {
        let obj = Object.assign(new ServiceAccountNativeDetailsForGcpOrganization(), model);
        ServiceAccountNativeDetailsForGcpOrganization.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForGcpOrganization>): ServiceAccountNativeDetailsForGcpOrganization {
        if (!model) return null;
        return ServiceAccountNativeDetailsForGcpOrganization.newInstance(<ServiceAccountNativeDetailsForGcpOrganization> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForGcpOrganization) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForGcpOrganization.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForGcpOrganization): boolean {
        if (models.ServiceAccountNativeDetailsBaseForGcp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForGcpOrganization.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Organization Id
     */
    organization_id: string;

    /**
     * Organization Name
     */
    organization_name: string;

}
